import { render, staticRenderFns } from "./Table_ia.vue?vue&type=template&id=12d168db&scoped=true&"
import script from "./Table_ia.vue?vue&type=script&lang=js&"
export * from "./Table_ia.vue?vue&type=script&lang=js&"
import style0 from "./Table_ia.vue?vue&type=style&index=0&id=12d168db&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d168db",
  null
  
)

export default component.exports